import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TaskType } from '../../enums/task.type';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { OrganisationSettingEnum } from '../../enums/organisation-settings';
import { CustomerService, OrganisationsService } from '../../services';
import { IHandoverTime } from '../../interfaces/handover-time';

@Component({
  selector: 'page-insurance-providers',
  templateUrl: './handover-times.html',
  styleUrls: ['./handover-times.scss'],
})
export class HandoverTimesComponent implements OnInit {
  organisationId = null;
  editHandoverTime: boolean = true;
  taskTypes: { taskTypeName: string; id: number }[] = [];
  customerOptions: { value: number; label: string }[] = [{ value: null, label: 'Default' }];
  handoverForm: FormGroup = null;
  customerName: string = 'Default';
  handoverTimes: IHandoverTime[];
  defaults: IHandoverTime[];

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private organisationService: OrganisationsService,
  ) {}

  ngOnInit() {
    this.getCustomerList();
    this.getTaskTypes();

    this.getDefaults().then(() => {
      this.createForm();
    });
  }

  getCustomerList() {
    this.organisationService.getAllCustomers().then((x) => {
      this.customerOptions = x.map((y) => {
        return { value: y.id, label: y.name };
      });
      this.customerOptions.unshift({ value: null, label: 'Default' });
    });
  }

  getTaskTypes() {
    let x = (
      Object.keys(TaskType)
        .map((key) => TaskType[key])
        .filter((value) => typeof value === 'string') as string[]
    ).map((y) => {
      return { id: TaskType[y], taskType: y };
    });

    x.forEach((y) => {
      const z = y.taskType.split(/(?=[A-Z])/).join(' ');
      this.taskTypes.push({ id: y.id, taskTypeName: z });
    });
  }

  get handoverTaskTypes(): FormArray {
    if (this.handoverForm != null) {
      return this.handoverForm.get('handoverTaskTypes') as FormArray;
    }
    return null;
  }

  saveHandoverTimes() {
    let handoverTimes: IHandoverTime[] = this.handoverTaskTypes.controls.map((x) => {
      return {
        taskTypeId: x.value.id,
        pickupHandoverMinutes: x.value.pickupHandoverMinutes,
        dropoffHandoverMinutes: x.value.dropoffHandoverMinutes,
      };
    });

    this.organisationService.setHandoverTimes(this.organisationId, handoverTimes).then((x) => {
      // This refreshes the form
      this.customerChanged();
    });
  }

  getDefaults() {
    return this.getHandoverTimes(null).then((x) => {
      this.defaults = x;
    });
  }

  customerChanged() {
    this.getHandoverTimes(this.organisationId).then((handoverTimes) => {
      this.handoverTimes = handoverTimes as IHandoverTime[];
      this.createForm();
    });
  }

  getHandoverTimes(organisationId: number) {
    return this.organisationService.getHandoverTimes(organisationId);
  }

  createForm() {
    let tt = [];

    this.taskTypes.forEach((x) => {
      let pickupHandoverMinutes = 20; // Default minutes
      let dropoffHandoverMinutes = 20; // Default minutes

      if (this.defaults != null) {
        const existing = this.defaults.find((z) => z.taskTypeId == x.id);

        if (existing != null) {
          pickupHandoverMinutes = existing.pickupHandoverMinutes;
          dropoffHandoverMinutes = existing.dropoffHandoverMinutes;
        }
      }

      if (this.handoverTimes) {
        const ex = this.handoverTimes.find((z) => z.taskTypeId == x.id);

        if (ex != null && ex.pickupHandoverMinutes != null) {
          pickupHandoverMinutes = ex.pickupHandoverMinutes;
        }
        if (ex != null && ex.dropoffHandoverMinutes != null) {
          dropoffHandoverMinutes = ex.dropoffHandoverMinutes;
        }
      }

      tt.push(
        this.fb.group({
          id: [x.id],
          name: [x.taskTypeName],
          pickupHandoverMinutes: [pickupHandoverMinutes],
          dropoffHandoverMinutes: [dropoffHandoverMinutes],
        }),
      );
    });

    this.handoverForm = this.fb.group({
      handoverTaskTypes: this.fb.array(tt, []),
    });
  }
}
